/**
 * 操作审计的操作类型名称与标签色（antd 预设色名）；未列出的类型直接显示原值
 */
import dayjs from 'dayjs'
const ACTION_LABELS: Record<string, string> = {
  admin_login: '管理员登录',
  login_attempt: '登录尝试',
  view_user_list: '查看用户列表',
  view_user_detail: '查看用户详情',
  update_user_status: '更新用户状态',
  delete_user: '删除用户',
  anonymize_user: '匿名化用户',
  batch_update_user_status: '批量更新用户状态',
  export_users: '导出用户数据',
  reset_user_password: '重置用户密码',
  clear_all_user_data: '清空用户学习数据'
}

const ACTION_COLORS: Record<string, string> = {
  admin_login: 'blue',
  login_attempt: 'cyan',
  update_user_status: 'orange',
  delete_user: 'red',
  anonymize_user: 'volcano',
  batch_update_user_status: 'orange',
  export_users: 'purple',
  reset_user_password: 'orange',
  clear_all_user_data: 'magenta'
}

export function actionLabel(action: string): string {
  return ACTION_LABELS[action] || action
}

export function actionColor(action: string): string {
  return ACTION_COLORS[action] || 'default'
}

export function formatAuditTime(value: string | null): string {
  return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '-'
}
